import { createFileRoute } from "@tanstack/react-router";
import { Users, Workflow, BarChart3 } from "lucide-react";
import { PlatformHub } from "@/components/marketing/PlatformHub";
import netImg from "@/assets/networking.jpg";

export const Route = createFileRoute("/platform/crm")({
  head: () => ({
    meta: [
      { title: "CRM — banana.cards" },
      { name: "description", content: "A modern CRM built around the way you actually meet people. Contacts, pipelines, tasks and real-time analytics." },
      { property: "og:title", content: "CRM — banana.cards" },
      { property: "og:description", content: "A modern CRM built around the way you actually meet people. Contacts, pipelines, tasks and real-time analytics." },
      { property: "og:image", content: netImg },
      { property: "og:url", content: "https://banana.cards/platform/crm" },
    ],
    links: [{ rel: "canonical", href: "https://banana.cards/platform/crm" }],
  }),
  component: Page,
});

function Page() {
  return (
    <PlatformHub
      eyebrow="CRM"
      title="A CRM that fills"
      italic="itself."
      description="Capture every contact at the moment you meet, move every deal forward, and see exactly what's working — all in one place."
      heroImage={netImg}
      heroImageAlt="Sales team using the banana.cards CRM to move deals through a pipeline and enrich networking contacts"
      features={[
        { title: "Contacts", desc: "Every lead captured, enriched and deduped automatically — from scans, forms, imports and integrations.", href: "/platform/contacts", icon: Users, bullets: ["Auto-enrichment", "Smart deduplication", "Tags, segments & lists"] },
        { title: "Pipelines & Tasks", desc: "Custom pipelines, drag-and-drop deals, auto-assigned tasks and SLA tracking — close faster.", href: "/platform/pipelines", icon: Workflow, bullets: ["Unlimited pipelines", "Tasks with SLAs", "Round-robin assignment"] },
        { title: "Analytics", desc: "Real-time dashboards across cards, contacts, deals, contracts and bookings — know what's working.", href: "/platform/analytics", icon: BarChart3, bullets: ["Real-time data", "Cohorts & funnels", "Custom reports"] },
      ]}
      outro={{ title: "Capture once.", italic: "Close more.", description: "A CRM that meets you where the conversation actually happens." }}
    />
  );
}